import React, { useState } from "react";
import { Palette } from "../AppConfig";
import { makeStyles } from "@material-ui/core/styles";
import { FormControlLabel, Switch, alpha, styled, Tooltip } from "@mui/material";

const BSL_StyledSwitch = styled(Switch)(({ theme }) => ({
    "& .MuiSwitch-switchBase.Mui-checked": {
        font: theme.brand?.FIELDERS
            ? "200 11pt " + Palette.Fielders.FontFamilySecondary
            : "400 14px " + Palette.Lysaght.FontFamily,
        color: theme.brand?.FIELDERS ? Palette.FieldersBlue : Palette.Lysaght.DarkBlue,
        "&:hover": {
            backgroundColor: alpha(
                theme.brand?.FIELDERS ? Palette.FieldersBlue : Palette.Lysaght.DarkBlue,
                theme.palette.action.hoverOpacity
            ),
        },
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
        backgroundColor: theme.brand?.FIELDERS ? Palette.FieldersBlue : Palette.Lysaght.DarkBlue,
    },
}));

const useStyles = makeStyles((theme) => ({
    root: {
        textShadow: "none",
    },
    input: {
        flex: "1",
        padding: "4px 0px",
        color: Palette.Control.DarkGrey,
        font: "14px " + theme.typography.fontFamily,
    },
    input_tight: {
        padding: "2px 0px 0px 0px",
        font: "13px " + theme.typography.fontFamily,
    },
    margin: {
        margin: "2px 2px 0px 8px",
    },
    menu_paper: {
        border: "1px solid " + Palette.Control.DarkBlueTrans,
    },
    thumbnail: {
        width: "80px",
        height: "24px",
        objectFit: "contain",
        paddingRight: "10px",
    },
    disabled: {
        color: Palette.Control.Grey,
    },
}));

export default function BSL_Switch({ switches, onChange, initialValues }) {
    const classes = useStyles();
    const [switchValues, setSwitchValues] = useState(initialValues || {});

    const handleSwitchChange = (event, index) => {
        const { name, checked } = event.target;
        setSwitchValues((prevValues) => ({ ...prevValues, [name]: checked }));

        if (onChange) {
            const updatedValues = { ...switchValues, [name]: checked };
            onChange(updatedValues, index);
        }
    };

    return (
        <>
            {switches.map((switchConfig, index) => (
                <Tooltip key={index} title={switchConfig?.title} placement="top" arrow>
                    <FormControlLabel
                        control={
                            <BSL_StyledSwitch
                                checked={switchValues[switchConfig.name] || false}
                                onChange={(event) => handleSwitchChange(event, index)}
                                name={switchConfig.name}
                            />
                        }
                        label={switchConfig.label}
                    />
                </Tooltip>
            ))}
        </>
    );
}
